// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: string;
};

export type SingleSignOnUserDto = {
  accountId: string;
  email: string;
};

export const Action = {
  MANAGE: 'MANAGE',
  CREATE: 'CREATE',
  READ: 'READ',
  READ_ALL: 'READ_ALL',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
} as const;

export type Action = (typeof Action)[keyof typeof Action];

export const Subject = {
  All: 'All',
  User: 'User',
  AdminLevel: 'AdminLevel',
  Organization: 'Organization',
  OrganizationUser: 'OrganizationUser',
  OrganizationStakeholder: 'OrganizationStakeholder',
  Sign: 'Sign',
  SignCode: 'SignCode',
  SignGroup: 'SignGroup',
  SignSupport: 'SignSupport',
  SignImage: 'SignImage',
  Process: 'Process',
  ProcessExamination: 'ProcessExamination',
  ProcessFile: 'ProcessFile',
} as const;

export type Subject = (typeof Subject)[keyof typeof Subject];

export type CaslEnumDto = {
  action: Action;
  subject: Subject;
};

export type CaslRulesDto = {
  rules: Array<
    Array<
      | Action
      | Subject
      | string
      | number
      | {
          [key: string]: unknown;
        }
    >
  >;
};

export const UserInstitutionType = {
  AUTHORITY: 'AUTHORITY',
  COMPANY: 'COMPANY',
  EDUCATIONAL_INSTITUTION: 'EDUCATIONAL_INSTITUTION',
  CLUB: 'CLUB',
  OTHER: 'OTHER',
} as const;

export type UserInstitutionType = (typeof UserInstitutionType)[keyof typeof UserInstitutionType];

export type CreateUserDto = {
  institutionType: UserInstitutionType;
  firstName: string;
  lastName: string;
  email: string;
  roleText: string;
  phoneNumber: string;
  organizationId?: string;
};

export const UserStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  REGISTERED: 'REGISTERED',
} as const;

export type UserStatus = (typeof UserStatus)[keyof typeof UserStatus];

export const UserRole = { ADMIN: 'ADMIN', USER: 'USER' } as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const UserNotificationInterval = {
  IMMEDIATE: 'IMMEDIATE',
  DAILY: 'DAILY',
  WEEKDAYS: 'WEEKDAYS',
  WEEKLY: 'WEEKLY',
  NEVER: 'NEVER',
} as const;

export type UserNotificationInterval = (typeof UserNotificationInterval)[keyof typeof UserNotificationInterval];

export const OrganizationUserRole = { MANAGER: 'MANAGER', EDITOR: 'EDITOR' } as const;

export type OrganizationUserRole = (typeof OrganizationUserRole)[keyof typeof OrganizationUserRole];

export const OrganizationType = {
  POLICE: 'POLICE',
  MISCELLANEOUS: 'MISCELLANEOUS',
  REGIONAL_COUNCIL: 'REGIONAL_COUNCIL',
  MUNICIPALITY: 'MUNICIPALITY',
  ROAD_TRAFFIC_AUTHORITY: 'ROAD_TRAFFIC_AUTHORITY',
  ROAD_CONSTRUCTION_AUTHORITY: 'ROAD_CONSTRUCTION_AUTHORITY',
  ROAD_MAINTENANCE_AUTHORITY: 'ROAD_MAINTENANCE_AUTHORITY',
  DISTRICT_OFFICE: 'DISTRICT_OFFICE',
  URBAN_DISTRICT: 'URBAN_DISTRICT',
  DISTRICT_CAPITAL: 'DISTRICT_CAPITAL',
  FEDERAL_AUTHORITY: 'FEDERAL_AUTHORITY',
} as const;

export type OrganizationType = (typeof OrganizationType)[keyof typeof OrganizationType];

export const OrganizationAdminLevelPermission = { EDIT: 'EDIT', VIEW: 'VIEW' } as const;

export type OrganizationAdminLevelPermission =
  (typeof OrganizationAdminLevelPermission)[keyof typeof OrganizationAdminLevelPermission];

export const AdminLevelType = {
  STATE: 'STATE',
  GOVERNMENT_DISTRICT: 'GOVERNMENT_DISTRICT',
  COUNTY: 'COUNTY',
  CITY_COUNTY: 'CITY_COUNTY',
  MUNICIPALITY: 'MUNICIPALITY',
} as const;

export type AdminLevelType = (typeof AdminLevelType)[keyof typeof AdminLevelType];

export type MultiPolygonDto = {
  type: 'MultiPolygon';
  coordinates: Array<Array<Array<Array<number>>>>;
};

export const SignSupportType = {
  POST: 'POST',
  FORK_STAND: 'FORK_STAND',
  TRI_POST: 'TRI_POST',
  WOOD_POST: 'WOOD_POST',
  OVERHEAD: 'OVERHEAD',
  OTHER: 'OTHER',
  UNKNOWN: 'UNKNOWN',
} as const;

export type SignSupportType = (typeof SignSupportType)[keyof typeof SignSupportType];

export type PointDto = {
  type: 'Point';
  coordinates: Array<number>;
};

export const SignGroupType = { FRAME: 'FRAME', NONE: 'NONE' } as const;

export type SignGroupType = (typeof SignGroupType)[keyof typeof SignGroupType];

export const SignGroupInstallationSide = { RIGHT: 'RIGHT', LEFT: 'LEFT' } as const;

export type SignGroupInstallationSide = (typeof SignGroupInstallationSide)[keyof typeof SignGroupInstallationSide];

export const SignStatusType = {
  DRAFT: 'DRAFT',
  PLACED: 'PLACED',
  DELETED: 'DELETED',
} as const;

export type SignStatusType = (typeof SignStatusType)[keyof typeof SignStatusType];

export const SignCategory = {
  MARKING: 'MARKING',
  DANGER: 'DANGER',
  REGULATION: 'REGULATION',
  DIRECTION: 'DIRECTION',
  TRAFFIC_GUIDANCE: 'TRAFFIC_GUIDANCE',
  TRAFFIC_FACILITY: 'TRAFFIC_FACILITY',
  OTHER: 'OTHER',
  ADDITION: 'ADDITION',
} as const;

export type SignCategory = (typeof SignCategory)[keyof typeof SignCategory];

export const SignSourceType = {
  MANUAL: 'MANUAL',
  EXTERNAL: 'EXTERNAL',
  MOBILE_MAPPING: 'MOBILE_MAPPING',
} as const;

export type SignSourceType = (typeof SignSourceType)[keyof typeof SignSourceType];

export const SignSize = {
  SIZE_1: 'SIZE_1',
  SIZE_2: 'SIZE_2',
  SIZE_3: 'SIZE_3',
} as const;

export type SignSize = (typeof SignSize)[keyof typeof SignSize];

export const SignReflectionClass = {
  RA_1: 'RA_1',
  RA_2: 'RA_2',
  RA_3: 'RA_3',
} as const;

export type SignReflectionClass = (typeof SignReflectionClass)[keyof typeof SignReflectionClass];

export const SignPermanency = {
  VARIABLE: 'VARIABLE',
  STATIC: 'STATIC',
  DYNAMIC: 'DYNAMIC',
} as const;

export type SignPermanency = (typeof SignPermanency)[keyof typeof SignPermanency];

export const SignCondition = {
  OK: 'OK',
  FADED: 'FADED',
  STICKERED: 'STICKERED',
  COVERED: 'COVERED',
  DIRTY: 'DIRTY',
  DAMAGED: 'DAMAGED',
} as const;

export type SignCondition = (typeof SignCondition)[keyof typeof SignCondition];

export type User = {
  __caslSubjectType__: Subject;
  institutionType: UserInstitutionType;
  status: UserStatus;
  role: UserRole;
  notificationInterval: UserNotificationInterval;
  firstName: string;
  lastName: string;
  email: string;
  accountId: string;
  registrationEmail: string;
  roleText?: string;
  phoneNumber: string;
  organization?: OrganizationUser;
  signStatusesCreated?: Array<SignStatus>;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type SignStatus = {
  __caslSubjectType__: Subject;
  type: SignStatusType;
  sign?: Sign;
  signId: string;
  createdBy?: User | null;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type SignImage = {
  __caslSubjectType__: Subject;
  width: number;
  height: number;
  sign: Sign;
  uploader?: string;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export const ProcessStatus = {
  DRAFT: 'DRAFT',
  EXAMINATION: 'EXAMINATION',
  DECISION: 'DECISION',
  EXECUTION: 'EXECUTION',
  FINALIZATION: 'FINALIZATION',
  REJECTED: 'REJECTED',
  ARCHIVED: 'ARCHIVED',
  CLOSED: 'CLOSED',
  CANCELLED: 'CANCELLED',
} as const;

export type ProcessStatus = (typeof ProcessStatus)[keyof typeof ProcessStatus];

export const ProcessReason = {
  SAFETY_AND_REGULATION: 'SAFETY_AND_REGULATION',
  PRESERVATION_NIGHTS_REST: 'PRESERVATION_NIGHTS_REST',
  PROTECTED_LANDSCAPE: 'PROTECTED_LANDSCAPE',
  ROAD_DAMAGE: 'ROAD_DAMAGE',
  URBAN_DEVELOPMENT: 'URBAN_DEVELOPMENT',
} as const;

export type ProcessReason = (typeof ProcessReason)[keyof typeof ProcessReason];

export const ProcessImplementationMethod = {
  INSTALLATION_OR_APPLICATION: 'INSTALLATION_OR_APPLICATION',
  ADAPTION_OR_MODIFICATION: 'ADAPTION_OR_MODIFICATION',
  REMOVAL: 'REMOVAL',
} as const;

export type ProcessImplementationMethod =
  (typeof ProcessImplementationMethod)[keyof typeof ProcessImplementationMethod];

export const ProcessImplementationType = {
  ROAD_MARKING: 'ROAD_MARKING',
  TRAFFIC_SIGN: 'TRAFFIC_SIGN',
  TRAFFIC_EQUIPMENT: 'TRAFFIC_EQUIPMENT',
  TRAFFIC_LIGHT: 'TRAFFIC_LIGHT',
  STOPPING_RESTRICTION_PROCESSIONS: 'STOPPING_RESTRICTION_PROCESSIONS',
  STOPPING_RESTRICTION_FILM_EVENTS: 'STOPPING_RESTRICTION_FILM_EVENTS',
  STOPPING_RESTRICTION_STREET_CLEANING: 'STOPPING_RESTRICTION_STREET_CLEANING',
  STOPPING_RESTRICTION_CITIZENS_OFFICE: 'STOPPING_RESTRICTION_CITIZENS_OFFICE',
} as const;

export type ProcessImplementationType = (typeof ProcessImplementationType)[keyof typeof ProcessImplementationType];

export const ProcessAllocationCostsType = {
  STVG_PARAGRAPH_5B_1: 'STVG_PARAGRAPH_5B_1',
  STVG_PARAGRAPH_5B_2: 'STVG_PARAGRAPH_5B_2',
  STVG_PARAGRAPH_5B_6: 'STVG_PARAGRAPH_5B_6',
} as const;

export type ProcessAllocationCostsType = (typeof ProcessAllocationCostsType)[keyof typeof ProcessAllocationCostsType];

export const ProcessAttachmentType = {
  LISTED_TRAFFIC_RESTRICTIONS: 'LISTED_TRAFFIC_RESTRICTIONS',
  MEMO: 'MEMO',
  ATTACHMENTS: 'ATTACHMENTS',
} as const;

export type ProcessAttachmentType = (typeof ProcessAttachmentType)[keyof typeof ProcessAttachmentType];

export const DecisionType = { AUTHORIZE: 'AUTHORIZE', ABORT: 'ABORT' } as const;

export type DecisionType = (typeof DecisionType)[keyof typeof DecisionType];

export const ExecutionType = {
  ARRANGEMENT: 'ARRANGEMENT',
  INSPECTION: 'INSPECTION',
  REMOVAL: 'REMOVAL',
} as const;

export type ExecutionType = (typeof ExecutionType)[keyof typeof ExecutionType];

export const ProcessFileType = {
  ATTACHMENT: 'ATTACHMENT',
  PROCESS_DOCUMENT: 'PROCESS_DOCUMENT',
  IMAGE: 'IMAGE',
} as const;

export type ProcessFileType = (typeof ProcessFileType)[keyof typeof ProcessFileType];

export type ProcessFile = {
  __caslSubjectType__: Subject;
  type: ProcessFileType;
  process: Process;
  processId: string;
  filename: string;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type SignSupportDto = {
  type: SignSupportType;
  id: string;
  createdAt: string;
  updatedAt: string;
  geometry: PointDto;
  description?: string;
  adminLevelId: string;
};

export type SignGroupDto = {
  type: SignGroupType;
  installationSide?: SignGroupInstallationSide;
  id: string;
  createdAt: string;
  updatedAt: string;
  order: number;
  support: SignSupportDto;
  bearing?: number;
  roadsideDistance?: number;
  sibId?: string;
};

export type SignStatusDto = {
  type: SignStatusType;
  createdAt: string;
};

export type SignImageDto = {
  id: string;
};

export type SignDto = {
  category: SignCategory;
  source: SignSourceType;
  size?: SignSize;
  reflectionClass?: SignReflectionClass;
  permanency?: SignPermanency;
  condition?: SignCondition;
  id: string;
  createdAt: string;
  updatedAt: string;
  code: string;
  group: SignGroupDto;
  order: number;
  status: SignStatusDto;
  value?: string;
  images?: Array<SignImageDto>;
};

export type UpdateSignExecutionDto = {
  size?: SignSize;
  reflectionClass?: SignReflectionClass;
  permanency?: SignPermanency;
  condition?: SignCondition;
  id: string;
  status: SignStatusDto;
  value?: string;
  images?: Array<SignImageDto>;
  supportType?: SignSupportType;
  modificationDate?: string;
  bearing?: number;
  geometry?: PointDto;
  sibId?: string;
};

export type SignChangeDto = {
  id: string;
  code: string;
};

export const ExaminationStatus = {
  OPEN: 'OPEN',
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
  CANCELLED: 'CANCELLED',
} as const;

export type ExaminationStatus = (typeof ExaminationStatus)[keyof typeof ExaminationStatus];

export const ExaminationType = {
  LINK: 'LINK',
  ASSIGNED: 'ASSIGNED',
  SELF_INPUT: 'SELF_INPUT',
} as const;

export type ExaminationType = (typeof ExaminationType)[keyof typeof ExaminationType];

export type ProcessExamination = {
  __caslSubjectType__: Subject;
  status: ExaminationStatus;
  type: ExaminationType;
  process: Process;
  processId: string;
  value?: string;
  valueUpdatedAt?: string;
  organization?: Organization;
  organizationId?: string;
  user?: User;
  userId?: string;
  contactOrganization?: string;
  contactName?: string;
  contactEmail?: string;
  readNotification: boolean;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type Process = {
  __caslSubjectType__: Subject;
  status: ProcessStatus;
  reason?: ProcessReason;
  implementationMethod?: ProcessImplementationMethod;
  implementationType?: ProcessImplementationType;
  allocationCosts?: ProcessAllocationCostsType;
  attachmentType?: ProcessAttachmentType;
  decisionType?: DecisionType;
  executionType?: ExecutionType;
  sequentialId: string;
  external: boolean;
  organization: Organization;
  organizationId: string;
  user: User;
  userId: string;
  cancelReason?: string;
  title?: string;
  statement?: string;
  location?: string;
  attachments?: Array<ProcessFile>;
  signs?: Array<ProcessSign>;
  signsDraft: Array<SignDto>;
  signsExecution: Array<UpdateSignExecutionDto>;
  signsChange: Array<SignChangeDto>;
  examinations: Array<ProcessExamination>;
  decisionComment?: string;
  executionAgency?: string;
  executionNotification?: string;
  executionUserEmail?: string;
  executionUpdatedAt?: string;
  validityDate?: string;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type ProcessSign = {
  __caslSubjectType__: Subject;
  processId: string;
  process?: Process;
  signId: string;
  sign?: Sign;
  createdAt: string;
  updatedAt: string;
};

export type Sign = {
  __caslSubjectType__: Subject;
  status: SignStatusType;
  category: SignCategory;
  source: SignSourceType;
  size?: SignSize;
  reflectionClass?: SignReflectionClass;
  permanency?: SignPermanency;
  condition?: SignCondition;
  code: string;
  group?: SignGroup;
  groupId: string;
  order: number;
  statuses?: Array<SignStatus>;
  value?: string;
  images?: Array<SignImage>;
  processes?: Array<ProcessSign>;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type SignGroup = {
  __caslSubjectType__: Subject;
  type: SignGroupType;
  installationSide?: SignGroupInstallationSide;
  order: number;
  support?: SignSupport;
  supportId: string;
  signs?: Array<Sign>;
  bearing?: number;
  roadsideDistance?: number;
  sibId?: string;
  openLRBinary?: string;
  openLRConfidence?: number;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type SignSupport = {
  __caslSubjectType__: Subject;
  type: SignSupportType;
  geometry: PointDto;
  description?: string;
  groups?: Array<SignGroup>;
  adminLevelId: string;
  adminLevel?: AdminLevel;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type AdminLevel = {
  __caslSubjectType__: Subject;
  type: AdminLevelType;
  /**
   * Amtlicher Regionalschlüssel (ARS)
   */
  regionalCode: string;
  id: string;
  wfsId: string;
  name: string;
  geometry?: MultiPolygonDto;
  parent?: AdminLevel;
  children?: Array<AdminLevel>;
  signSupports?: Array<SignSupport>;
  organizations?: Array<OrganizationAdminLevel>;
  createdAt: string;
  updatedAt: string;
};

export type OrganizationAdminLevel = {
  __caslSubjectType__: Subject;
  permission: OrganizationAdminLevelPermission;
  organizationId: string;
  organization?: Organization;
  adminLevelId: string;
  adminLevel?: AdminLevel;
  createdAt: string;
  updatedAt: string;
};

export type OrganizationStakeholder = {
  __caslSubjectType__: Subject;
  type: ExaminationType;
  organization: Organization;
  stakeholderOrganizationId?: string;
  stakeholderOrganization?: Organization;
  stakeholderUserId?: string;
  stakeholderUser?: User;
  contactOrganization?: string;
  contactUser?: string;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type Organization = {
  __caslSubjectType__: Subject;
  type: OrganizationType;
  name: string;
  bemasId?: string | null;
  active: boolean;
  street?: string | null;
  postalCode?: string | null;
  city?: string | null;
  phoneNumber?: string | null;
  mobileNumber?: string | null;
  email?: string | null;
  adminLevels?: Array<OrganizationAdminLevel>;
  users?: Array<OrganizationUser>;
  stakeholders?: Array<OrganizationStakeholder>;
  letterHead?: string;
  id: string;
  createdAt: string;
  updatedAt: string;
};

export type OrganizationUser = {
  __caslSubjectType__: Subject;
  role: OrganizationUserRole;
  organizationId: string;
  organization?: Organization;
  userId: string;
  user?: User;
  active: boolean;
  createdAt: string;
  updatedAt: string;
};

export type UpdateUserDto = {
  institutionType?: UserInstitutionType;
  firstName?: string;
  lastName?: string;
  email?: string;
  roleText?: string;
  phoneNumber?: string;
  status?: UserStatus;
  role?: UserRole;
  notificationInterval?: UserNotificationInterval;
};

export type GeocoderFeaturePropertiesDto = {
  text: string;
};

export type GeocoderFeatureDto = {
  type: 'Feature';
  geometry: PointDto;
  id: string;
  properties: GeocoderFeaturePropertiesDto;
};

export type GeocoderFeatureCollectionDto = {
  type: 'FeatureCollection';
  features: Array<GeocoderFeatureDto>;
};

export type CreateOrganizationDto = {
  type: OrganizationType;
  name: string;
};

export type UpdateOrganizationDto = {
  type?: OrganizationType;
  name?: string;
  active?: boolean;
  email?: string | null;
  postalCode?: string | null;
  city?: string | null;
  street?: string | null;
  phoneNumber?: string | null;
  mobileNumber?: string | null;
  letterHead?: string | null;
};

export type CreateOrganizationAdminLevelDto = {
  permission: OrganizationAdminLevelPermission;
};

export type UpdateOrganizationAdminLevelDto = {
  permission?: OrganizationAdminLevelPermission;
};

export type CreateOrganizationUserDto = {
  role: OrganizationUserRole;
  active?: boolean;
};

export type UpdateOrganizationUserDto = {
  role?: OrganizationUserRole;
  active?: boolean;
};

export type CreateOrganizationStakeholderDto = {
  type: ExaminationType;
  stakeholderOrganizationId?: string;
  stakeholderUserId?: string;
  contactOrganization?: string;
  contactUser?: string;
};

export type SignSupportAggregationDto = {
  bearing?: number | null;
  codes: Array<string>;
};

export type SignSupportViewPropertiesDto = {
  id: string;
  aggregation: Array<SignSupportAggregationDto>;
};

export type CreateSignGroupSignDto = {
  source?: SignSourceType;
  size?: SignSize;
  reflectionClass?: SignReflectionClass;
  permanency?: SignPermanency;
  code: string;
  order: number;
  value?: string;
};

export type CreateSignSupportGroupDto = {
  type: SignGroupType;
  installationSide?: SignGroupInstallationSide;
  bearing?: number;
  roadsideDistance?: number;
  order: number;
  signs?: Array<CreateSignGroupSignDto>;
  sibId?: string;
};

export type CreateSignSupportDto = {
  type: SignSupportType;
  adminLevelId: string;
  geometry: PointDto;
  description?: string;
  groups?: Array<CreateSignSupportGroupDto>;
};

export type UpdateSignSupportDto = {
  type?: SignSupportType;
  adminLevelId?: string;
  geometry?: PointDto;
  description?: string;
  groups?: Array<CreateSignSupportGroupDto>;
  groupsOrder?: Array<string>;
};

export type CreateSignGroupDto = {
  type: SignGroupType;
  installationSide?: SignGroupInstallationSide;
  supportId: string;
  bearing?: number;
  roadsideDistance?: number;
  order: number;
  signs?: Array<CreateSignGroupSignDto>;
  sibId?: string;
};

export type UpdateSignGroupDto = {
  type?: SignGroupType;
  installationSide?: SignGroupInstallationSide;
  supportId?: string;
  bearing?: number;
  roadsideDistance?: number;
  order?: number;
  signs?: Array<CreateSignGroupSignDto>;
  sibId?: string;
  signsOrder?: Array<string>;
};

export type CreateSignDto = {
  source?: SignSourceType;
  size?: SignSize;
  reflectionClass?: SignReflectionClass;
  permanency?: SignPermanency;
  code: string;
  groupId: string;
  order: number;
  value?: string;
};

export const SignsOrderProperty = {
  createdAt: 'createdAt',
  source: 'source',
  category: 'category',
  code: 'code',
  status: 'status',
} as const;

export type SignsOrderProperty = (typeof SignsOrderProperty)[keyof typeof SignsOrderProperty];

export type SignPaginationMetadataDto = {
  data: Array<Sign>;
  total: number;
  page: number;
  limit: number;
};

export type SuggestionSign = {
  status: SignStatusType;
  category: SignCategory;
  source: SignSourceType;
  permanency?: SignPermanency;
  id: string;
  code: string;
  value?: string;
  bearing?: number;
  geometry: PointDto;
};

export type UpdateSignDto = {
  source?: SignSourceType;
  size?: SignSize;
  reflectionClass?: SignReflectionClass;
  permanency?: SignPermanency;
  code?: string;
  groupId?: string;
  order?: number;
  value?: string;
  condition?: SignCondition;
};

export type CreateSignStatusDto = {
  type: SignStatusType;
};

export type SignCode = {
  category: SignCategory;
  code: string;
  description: string;
  icon?: string;
  tnitsCode?: string;
};

export type CreateProcessDto = {
  implementationMethod?: ProcessImplementationMethod;
  signIds?: Array<string>;
  external?: boolean;
  sequentialId?: string;
};

export const NotificationType = { UNREAD: 'UNREAD', STATEMENT_REQUEST: 'STATEMENT_REQUEST' } as const;

export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];

export type UpdateProcessDto = {
  implementationMethod?: ProcessImplementationMethod;
  signIds?: Array<string>;
  external?: boolean;
  sequentialId?: string;
  status?: ProcessStatus;
  reason?: ProcessReason;
  implementationType?: ProcessImplementationType;
  allocationCosts?: ProcessAllocationCostsType;
  attachmentType?: ProcessAttachmentType;
  decisionType?: DecisionType;
  executionType?: ExecutionType;
  organizationId?: string;
  userId?: string;
  cancelReason?: string;
  title?: string;
  statement?: string;
  location?: string;
  attachments?: Array<string>;
  decisionComment?: string;
  executionAgency?: string;
  executionNotification?: string;
  validityDate?: string;
};

export type UpdateExternalProcessDto = {
  sequentialId?: string;
  status?: ProcessStatus;
  validityDate?: string;
  signsPlacedDate?: string;
  executionNotification?: string;
};

export const ProcessAction = {
  PREVIOUS_STEP: 'PREVIOUS_STEP',
  SAVE: 'SAVE',
  NEXT_STEP: 'NEXT_STEP',
} as const;

export type ProcessAction = (typeof ProcessAction)[keyof typeof ProcessAction];

export type UpdateProcessStepDraftDto = {
  reason?: ProcessReason;
  implementationMethod: ProcessImplementationMethod;
  implementationType?: ProcessImplementationType;
  allocationCosts?: ProcessAllocationCostsType;
  attachmentType?: ProcessAttachmentType;
  title?: string;
  statement?: string;
  location?: string;
  signsChange?: Array<SignChangeDto>;
};

export type UpdateProcessStepDecisionDto = {
  decisionType?: DecisionType;
  decisionComment?: string;
  validityDate?: string;
};

export type UpdateProcessStepExecutionDto = {
  executionType?: ExecutionType;
  executionAgency?: string;
};

export type FinalizeProcessDto = {
  signs: Array<UpdateSignExecutionDto>;
};

export type CancelProcessDto = {
  cancelReason?: string;
};

export type ProcessFileDto = {
  type: ProcessFileType;
  id: string;
  updatedAt: string;
  filename: string;
};

export type CreateProcessExaminationDto = {
  type: ExaminationType;
  readNotification?: boolean;
  contactOrganization?: string;
  contactName?: string;
  organizationId?: string;
  userId?: string;
};

export type UpdateProcessExaminationDto = {
  type?: ExaminationType;
  readNotification?: boolean;
  contactOrganization?: string;
  contactName?: string;
  organizationId?: string;
  userId?: string;
  status?: ExaminationStatus;
  value?: string;
};

export type PublicProcessDto = {
  status: ProcessStatus;
  implementationMethod?: ProcessImplementationMethod;
  executionType?: ExecutionType;
  executionAgency?: string;
  executionNotification?: string;
  id: string;
  sequentialId: string;
  signsDraft: Array<SignDto>;
  signsExecution: Array<UpdateSignExecutionDto>;
  signsChange: Array<SignChangeDto>;
};

export type UpdateProcessExecutionDto = {
  signsExecution: Array<UpdateSignExecutionDto>;
  executionNotification?: string;
};

export type HealthCheckData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/health';
};

export type HealthCheckErrors = {
  /**
   * The Health Check is not successful
   */
  503: {
    status?: string;
    info?: {
      [key: string]: {
        status: string;
        [key: string]: unknown | string;
      };
    } | null;
    error?: {
      [key: string]: {
        status: string;
        [key: string]: unknown | string;
      };
    } | null;
    details?: {
      [key: string]: {
        status: string;
        [key: string]: unknown | string;
      };
    };
  };
};

export type HealthCheckError = HealthCheckErrors[keyof HealthCheckErrors];

export type HealthCheckResponses = {
  /**
   * The Health Check is successful
   */
  200: {
    status?: string;
    info?: {
      [key: string]: {
        status: string;
        [key: string]: unknown | string;
      };
    } | null;
    error?: {
      [key: string]: {
        status: string;
        [key: string]: unknown | string;
      };
    } | null;
    details?: {
      [key: string]: {
        status: string;
        [key: string]: unknown | string;
      };
    };
  };
};

export type HealthCheckResponse = HealthCheckResponses[keyof HealthCheckResponses];

export type AuthenticationLoginData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication/login';
};

export type AuthenticationLoginResponses = {
  200: unknown;
};

export type AuthenticationSamlAssertionConsumerData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication/saml/assertion-consumer';
};

export type AuthenticationSamlAssertionConsumerResponses = {
  201: unknown;
};

export type AuthenticationLogoutData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication/logout';
};

export type AuthenticationLogoutResponses = {
  201: unknown;
};

export type AuthenticationSamlLogoutData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication/saml-logout';
};

export type AuthenticationSamlLogoutResponses = {
  201: unknown;
};

export type AuthenticationSamlSingleLogoutData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication/saml/single-logout';
};

export type AuthenticationSamlSingleLogoutResponses = {
  200: unknown;
};

export type AuthenticationSamlMetadataData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication/saml/metadata';
};

export type AuthenticationSamlMetadataResponses = {
  200: Blob | File;
};

export type AuthenticationSamlMetadataResponse =
  AuthenticationSamlMetadataResponses[keyof AuthenticationSamlMetadataResponses];

export type AuthenticationGetUserData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication';
};

export type AuthenticationGetUserResponses = {
  200: User | SingleSignOnUserDto;
};

export type AuthenticationGetUserResponse = AuthenticationGetUserResponses[keyof AuthenticationGetUserResponses];

export type AuthenticationGetWfsAuthorizationData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/authentication/wfs';
};

export type AuthenticationGetWfsAuthorizationResponses = {
  200: boolean;
};

export type AuthenticationGetWfsAuthorizationResponse =
  AuthenticationGetWfsAuthorizationResponses[keyof AuthenticationGetWfsAuthorizationResponses];

export type CaslGetRulesData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/casl';
};

export type CaslGetRulesResponses = {
  200: CaslRulesDto;
};

export type CaslGetRulesResponse = CaslGetRulesResponses[keyof CaslGetRulesResponses];

export type UsersFindAllData = {
  body?: never;
  path?: never;
  query?: {
    search?: string;
    status?: Array<UserStatus>;
    role?: Array<UserRole>;
  };
  url: '/api/users';
};

export type UsersFindAllResponses = {
  200: Array<User>;
};

export type UsersFindAllResponse = UsersFindAllResponses[keyof UsersFindAllResponses];

export type UsersCreateData = {
  body: CreateUserDto;
  path?: never;
  query?: never;
  url: '/api/users';
};

export type UsersCreateResponses = {
  201: User;
};

export type UsersCreateResponse = UsersCreateResponses[keyof UsersCreateResponses];

export type UsersRemoveData = {
  body?: never;
  path: {
    userId: string;
  };
  query?: never;
  url: '/api/users/{userId}';
};

export type UsersRemoveResponses = {
  200: User;
};

export type UsersRemoveResponse = UsersRemoveResponses[keyof UsersRemoveResponses];

export type UsersFindOneData = {
  body?: never;
  path: {
    userId: string;
  };
  query?: never;
  url: '/api/users/{userId}';
};

export type UsersFindOneResponses = {
  200: User;
};

export type UsersFindOneResponse = UsersFindOneResponses[keyof UsersFindOneResponses];

export type UsersUpdateData = {
  body: UpdateUserDto;
  path: {
    userId: string;
  };
  query?: never;
  url: '/api/users/{userId}';
};

export type UsersUpdateResponses = {
  200: User;
};

export type UsersUpdateResponse = UsersUpdateResponses[keyof UsersUpdateResponses];

export type AdminLevelsFindAllData = {
  body?: never;
  path?: never;
  query?: {
    type?: Array<AdminLevelType>;
  };
  url: '/api/admin-levels';
};

export type AdminLevelsFindAllResponses = {
  200: Array<AdminLevel>;
};

export type AdminLevelsFindAllResponse = AdminLevelsFindAllResponses[keyof AdminLevelsFindAllResponses];

export type AdminLevelsFindOneData = {
  body?: never;
  path: {
    adminLevelId: string;
  };
  query?: {
    parents?: boolean;
    children?: boolean;
    organizations?: boolean;
  };
  url: '/api/admin-levels/{adminLevelId}';
};

export type AdminLevelsFindOneResponses = {
  200: AdminLevel;
};

export type AdminLevelsFindOneResponse = AdminLevelsFindOneResponses[keyof AdminLevelsFindOneResponses];

export type GeocoderGeocodeData = {
  body?: never;
  path: {
    query: string;
  };
  query?: never;
  url: '/api/geocoder/geocode/{query}';
};

export type GeocoderGeocodeResponses = {
  200: GeocoderFeatureCollectionDto;
};

export type GeocoderGeocodeResponse = GeocoderGeocodeResponses[keyof GeocoderGeocodeResponses];

export type GeocoderReverseData = {
  body?: never;
  path: {
    longitude: number;
    latitude: number;
  };
  query?: never;
  url: '/api/geocoder/reverse/{longitude}/{latitude}';
};

export type GeocoderReverseResponses = {
  200: GeocoderFeatureDto;
};

export type GeocoderReverseResponse = GeocoderReverseResponses[keyof GeocoderReverseResponses];

export type OrganizationsFindAllData = {
  body?: never;
  path?: never;
  query?: {
    type?: Array<OrganizationType>;
    active?: boolean;
  };
  url: '/api/organizations';
};

export type OrganizationsFindAllResponses = {
  200: Array<Organization>;
};

export type OrganizationsFindAllResponse = OrganizationsFindAllResponses[keyof OrganizationsFindAllResponses];

export type OrganizationsCreateData = {
  body: CreateOrganizationDto;
  path?: never;
  query?: never;
  url: '/api/organizations';
};

export type OrganizationsCreateResponses = {
  201: Organization;
};

export type OrganizationsCreateResponse = OrganizationsCreateResponses[keyof OrganizationsCreateResponses];

export type OrganizationsFindOneData = {
  body?: never;
  path: {
    organizationId: string;
  };
  query?: {
    adminLevels?: boolean;
    users?: boolean;
    usersActive?: boolean;
    stakeholders?: boolean;
  };
  url: '/api/organizations/{organizationId}';
};

export type OrganizationsFindOneResponses = {
  200: Organization;
};

export type OrganizationsFindOneResponse = OrganizationsFindOneResponses[keyof OrganizationsFindOneResponses];

export type OrganizationsUpdateData = {
  body: UpdateOrganizationDto;
  path: {
    organizationId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}';
};

export type OrganizationsUpdateResponses = {
  200: Organization;
};

export type OrganizationsUpdateResponse = OrganizationsUpdateResponses[keyof OrganizationsUpdateResponses];

export type OrganizationsRemoveOrganizationAdminLevelData = {
  body?: never;
  path: {
    organizationId: string;
    adminLevelId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/admin-levels/{adminLevelId}';
};

export type OrganizationsRemoveOrganizationAdminLevelResponses = {
  200: OrganizationAdminLevel;
};

export type OrganizationsRemoveOrganizationAdminLevelResponse =
  OrganizationsRemoveOrganizationAdminLevelResponses[keyof OrganizationsRemoveOrganizationAdminLevelResponses];

export type OrganizationsFindOneOrganizationAdminLevelData = {
  body?: never;
  path: {
    organizationId: string;
    adminLevelId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/admin-levels/{adminLevelId}';
};

export type OrganizationsFindOneOrganizationAdminLevelResponses = {
  200: OrganizationAdminLevel;
};

export type OrganizationsFindOneOrganizationAdminLevelResponse =
  OrganizationsFindOneOrganizationAdminLevelResponses[keyof OrganizationsFindOneOrganizationAdminLevelResponses];

export type OrganizationsUpdateOrganizationAdminLevelData = {
  body: UpdateOrganizationAdminLevelDto;
  path: {
    organizationId: string;
    adminLevelId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/admin-levels/{adminLevelId}';
};

export type OrganizationsUpdateOrganizationAdminLevelResponses = {
  200: OrganizationAdminLevel;
};

export type OrganizationsUpdateOrganizationAdminLevelResponse =
  OrganizationsUpdateOrganizationAdminLevelResponses[keyof OrganizationsUpdateOrganizationAdminLevelResponses];

export type OrganizationsCreateOrganizationAdminLevelData = {
  body: CreateOrganizationAdminLevelDto;
  path: {
    organizationId: string;
    adminLevelId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/admin-levels/{adminLevelId}';
};

export type OrganizationsCreateOrganizationAdminLevelResponses = {
  201: OrganizationAdminLevel;
};

export type OrganizationsCreateOrganizationAdminLevelResponse =
  OrganizationsCreateOrganizationAdminLevelResponses[keyof OrganizationsCreateOrganizationAdminLevelResponses];

export type OrganizationsRemoveOrganizationUserData = {
  body?: never;
  path: {
    organizationId: string;
    userId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/users/{userId}';
};

export type OrganizationsRemoveOrganizationUserResponses = {
  200: OrganizationUser;
};

export type OrganizationsRemoveOrganizationUserResponse =
  OrganizationsRemoveOrganizationUserResponses[keyof OrganizationsRemoveOrganizationUserResponses];

export type OrganizationsFindOneOrganizationUserData = {
  body?: never;
  path: {
    organizationId: string;
    userId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/users/{userId}';
};

export type OrganizationsFindOneOrganizationUserResponses = {
  200: OrganizationUser;
};

export type OrganizationsFindOneOrganizationUserResponse =
  OrganizationsFindOneOrganizationUserResponses[keyof OrganizationsFindOneOrganizationUserResponses];

export type OrganizationsUpdateOrganizationUserData = {
  body: UpdateOrganizationUserDto;
  path: {
    organizationId: string;
    userId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/users/{userId}';
};

export type OrganizationsUpdateOrganizationUserResponses = {
  200: OrganizationUser;
};

export type OrganizationsUpdateOrganizationUserResponse =
  OrganizationsUpdateOrganizationUserResponses[keyof OrganizationsUpdateOrganizationUserResponses];

export type OrganizationsCreateOrganizationUserData = {
  body: CreateOrganizationUserDto;
  path: {
    organizationId: string;
    userId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/users/{userId}';
};

export type OrganizationsCreateOrganizationUserResponses = {
  201: OrganizationUser;
};

export type OrganizationsCreateOrganizationUserResponse =
  OrganizationsCreateOrganizationUserResponses[keyof OrganizationsCreateOrganizationUserResponses];

export type OrganizationsFindOrganizationStakeholderData = {
  body?: never;
  path: {
    organizationId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/stakeholders';
};

export type OrganizationsFindOrganizationStakeholderResponses = {
  200: Array<OrganizationStakeholder>;
};

export type OrganizationsFindOrganizationStakeholderResponse =
  OrganizationsFindOrganizationStakeholderResponses[keyof OrganizationsFindOrganizationStakeholderResponses];

export type OrganizationsCreateOrganizationStakeholderData = {
  body: CreateOrganizationStakeholderDto;
  path: {
    organizationId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/stakeholders';
};

export type OrganizationsCreateOrganizationStakeholderResponses = {
  201: OrganizationStakeholder;
};

export type OrganizationsCreateOrganizationStakeholderResponse =
  OrganizationsCreateOrganizationStakeholderResponses[keyof OrganizationsCreateOrganizationStakeholderResponses];

export type OrganizationsRemoveOrganizationStakeholderData = {
  body?: never;
  path: {
    organizationId: string;
    stakeholderId: string;
  };
  query?: never;
  url: '/api/organizations/{organizationId}/stakeholders/{stakeholderId}';
};

export type OrganizationsRemoveOrganizationStakeholderResponses = {
  200: OrganizationStakeholder;
};

export type OrganizationsRemoveOrganizationStakeholderResponse =
  OrganizationsRemoveOrganizationStakeholderResponses[keyof OrganizationsRemoveOrganizationStakeholderResponses];

export type SignSupportsCreateData = {
  body: CreateSignSupportDto;
  path?: never;
  query?: never;
  url: '/api/sign-supports';
};

export type SignSupportsCreateResponses = {
  201: SignSupport;
};

export type SignSupportsCreateResponse = SignSupportsCreateResponses[keyof SignSupportsCreateResponses];

export type SignSupportsRemoveData = {
  body?: never;
  path: {
    signSupportId: string;
  };
  query?: never;
  url: '/api/sign-supports/{signSupportId}';
};

export type SignSupportsRemoveResponses = {
  200: SignSupport;
};

export type SignSupportsRemoveResponse = SignSupportsRemoveResponses[keyof SignSupportsRemoveResponses];

export type SignSupportsFindOneData = {
  body?: never;
  path: {
    signSupportId: string;
  };
  query?: never;
  url: '/api/sign-supports/{signSupportId}';
};

export type SignSupportsFindOneResponses = {
  200: SignSupport;
};

export type SignSupportsFindOneResponse = SignSupportsFindOneResponses[keyof SignSupportsFindOneResponses];

export type SignSupportsUpdateData = {
  body: UpdateSignSupportDto;
  path: {
    signSupportId: string;
  };
  query?: never;
  url: '/api/sign-supports/{signSupportId}';
};

export type SignSupportsUpdateResponses = {
  200: SignSupport;
};

export type SignSupportsUpdateResponse = SignSupportsUpdateResponses[keyof SignSupportsUpdateResponses];

export type SignGroupsCreateData = {
  body: CreateSignGroupDto;
  path?: never;
  query?: never;
  url: '/api/sign-groups';
};

export type SignGroupsCreateResponses = {
  201: SignGroup;
};

export type SignGroupsCreateResponse = SignGroupsCreateResponses[keyof SignGroupsCreateResponses];

export type SignGroupsRemoveData = {
  body?: never;
  path: {
    signGroupId: string;
  };
  query?: never;
  url: '/api/sign-groups/{signGroupId}';
};

export type SignGroupsRemoveResponses = {
  200: SignGroup;
};

export type SignGroupsRemoveResponse = SignGroupsRemoveResponses[keyof SignGroupsRemoveResponses];

export type SignGroupsFindOneData = {
  body?: never;
  path: {
    signGroupId: string;
  };
  query?: never;
  url: '/api/sign-groups/{signGroupId}';
};

export type SignGroupsFindOneResponses = {
  200: SignGroup;
};

export type SignGroupsFindOneResponse = SignGroupsFindOneResponses[keyof SignGroupsFindOneResponses];

export type SignGroupsUpdateData = {
  body: UpdateSignGroupDto;
  path: {
    signGroupId: string;
  };
  query?: never;
  url: '/api/sign-groups/{signGroupId}';
};

export type SignGroupsUpdateResponses = {
  200: SignGroup;
};

export type SignGroupsUpdateResponse = SignGroupsUpdateResponses[keyof SignGroupsUpdateResponses];

export type SignGroupsUpdateOpenLrData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/sign-groups/update-open-lr';
};

export type SignGroupsUpdateOpenLrResponses = {
  201: unknown;
};

export type SignsFindAllData = {
  body?: never;
  path?: never;
  query: {
    status?: Array<SignStatusType>;
    category?: Array<SignCategory>;
    source?: Array<SignSourceType>;
    size?: Array<SignSize>;
    reflectionClass?: Array<SignReflectionClass>;
    orderBy?: SignsOrderProperty;
    page: number;
    limit: number;
    organizationId?: string;
    adminLevelId?: string;
    adminLevelIds?: Array<string>;
    search?: string;
    createdAtMin?: string;
    createdAtMax?: string;
    updatedAtMin?: string;
    updatedAtMax?: string;
    order?: number;
    orderDesc?: boolean;
  };
  url: '/api/signs';
};

export type SignsFindAllResponses = {
  200: SignPaginationMetadataDto;
};

export type SignsFindAllResponse = SignsFindAllResponses[keyof SignsFindAllResponses];

export type SignsCreateData = {
  body: CreateSignDto;
  path?: never;
  query?: never;
  url: '/api/signs';
};

export type SignsCreateResponses = {
  201: Sign;
};

export type SignsCreateResponse = SignsCreateResponses[keyof SignsCreateResponses];

export type SignsFindAllProcessSuggestionData = {
  body?: never;
  path?: never;
  query?: {
    adminLevelId?: unknown;
  };
  url: '/api/signs/process-suggestion';
};

export type SignsFindAllProcessSuggestionResponses = {
  200: Array<SuggestionSign>;
};

export type SignsFindAllProcessSuggestionResponse =
  SignsFindAllProcessSuggestionResponses[keyof SignsFindAllProcessSuggestionResponses];

export type SignsRemoveData = {
  body?: never;
  path: {
    signId: string;
  };
  query?: never;
  url: '/api/signs/{signId}';
};

export type SignsRemoveResponses = {
  200: Sign;
};

export type SignsRemoveResponse = SignsRemoveResponses[keyof SignsRemoveResponses];

export type SignsFindOneData = {
  body?: never;
  path: {
    signId: string;
  };
  query?: never;
  url: '/api/signs/{signId}';
};

export type SignsFindOneResponses = {
  200: Sign;
};

export type SignsFindOneResponse = SignsFindOneResponses[keyof SignsFindOneResponses];

export type SignsUpdateData = {
  body: UpdateSignDto;
  path: {
    signId: string;
  };
  query?: never;
  url: '/api/signs/{signId}';
};

export type SignsUpdateResponses = {
  200: Sign;
};

export type SignsUpdateResponse = SignsUpdateResponses[keyof SignsUpdateResponses];

export type SignsCreateStatusData = {
  body: CreateSignStatusDto;
  path: {
    signId: string;
  };
  query?: never;
  url: '/api/signs/{signId}/statuses';
};

export type SignsCreateStatusResponses = {
  201: SignStatus;
};

export type SignsCreateStatusResponse = SignsCreateStatusResponses[keyof SignsCreateStatusResponses];

export type SignCodesFindAllData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/sign-codes';
};

export type SignCodesFindAllResponses = {
  200: Array<SignCode>;
};

export type SignCodesFindAllResponse = SignCodesFindAllResponses[keyof SignCodesFindAllResponses];

export type SignCodesFindOneData = {
  body?: never;
  path: {
    code: string;
  };
  query?: never;
  url: '/api/sign-codes/{code}';
};

export type SignCodesFindOneResponses = {
  200: SignCode;
};

export type SignCodesFindOneResponse = SignCodesFindOneResponses[keyof SignCodesFindOneResponses];

export type BemasImportImportPoliceData = {
  body: {
    file?: Blob | File;
  };
  path?: never;
  query?: never;
  url: '/api/bemas-import/police';
};

export type BemasImportImportPoliceResponses = {
  201: string;
};

export type BemasImportImportPoliceResponse = BemasImportImportPoliceResponses[keyof BemasImportImportPoliceResponses];

export type BemasImportImportOrganizationsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/bemas-import/organizations';
};

export type BemasImportImportOrganizationsResponses = {
  201: boolean;
};

export type BemasImportImportOrganizationsResponse =
  BemasImportImportOrganizationsResponses[keyof BemasImportImportOrganizationsResponses];

export type ProcessesFindAllData = {
  body?: never;
  path?: never;
  query?: {
    signIds?: Array<string>;
    examinationDetails?: boolean;
  };
  url: '/api/processes';
};

export type ProcessesFindAllResponses = {
  200: Array<Process>;
};

export type ProcessesFindAllResponse = ProcessesFindAllResponses[keyof ProcessesFindAllResponses];

export type ProcessesCreateData = {
  body: CreateProcessDto;
  path?: never;
  query?: never;
  url: '/api/processes';
};

export type ProcessesCreateResponses = {
  201: Process;
};

export type ProcessesCreateResponse = ProcessesCreateResponses[keyof ProcessesCreateResponses];

export type ProcessesFindAllNotificationsData = {
  body?: never;
  path?: never;
  query: {
    type: NotificationType;
    userId: string;
  };
  url: '/api/processes/notifications';
};

export type ProcessesFindAllNotificationsResponses = {
  200: Array<Process>;
};

export type ProcessesFindAllNotificationsResponse =
  ProcessesFindAllNotificationsResponses[keyof ProcessesFindAllNotificationsResponses];

export type ProcessesRemoveData = {
  body?: never;
  path: {
    processId: string;
  };
  query?: never;
  url: '/api/processes/{processId}';
};

export type ProcessesRemoveResponses = {
  200: Process;
};

export type ProcessesRemoveResponse = ProcessesRemoveResponses[keyof ProcessesRemoveResponses];

export type ProcessesFindOneData = {
  body?: never;
  path: {
    processId: string;
  };
  query?: never;
  url: '/api/processes/{processId}';
};

export type ProcessesFindOneResponses = {
  200: Process;
};

export type ProcessesFindOneResponse = ProcessesFindOneResponses[keyof ProcessesFindOneResponses];

export type ProcessesUpdateData = {
  body: UpdateProcessDto;
  path: {
    processId: string;
  };
  query?: never;
  url: '/api/processes/{processId}';
};

export type ProcessesUpdateResponses = {
  200: Process;
};

export type ProcessesUpdateResponse = ProcessesUpdateResponses[keyof ProcessesUpdateResponses];

export type ProcessesUpdateExternalData = {
  body: UpdateExternalProcessDto;
  path: {
    processId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/external';
};

export type ProcessesUpdateExternalResponses = {
  200: Process;
};

export type ProcessesUpdateExternalResponse = ProcessesUpdateExternalResponses[keyof ProcessesUpdateExternalResponses];

export type ProcessesUpdateStepDraftData = {
  body: UpdateProcessStepDraftDto;
  path: {
    processId: string;
  };
  query: {
    action: ProcessAction;
  };
  url: '/api/processes/{processId}/step-draft';
};

export type ProcessesUpdateStepDraftResponses = {
  200: Process;
};

export type ProcessesUpdateStepDraftResponse =
  ProcessesUpdateStepDraftResponses[keyof ProcessesUpdateStepDraftResponses];

export type ProcessesUpdateStepExaminationData = {
  body?: never;
  path: {
    processId: string;
  };
  query: {
    action: ProcessAction;
  };
  url: '/api/processes/{processId}/step-examination';
};

export type ProcessesUpdateStepExaminationResponses = {
  200: Process;
};

export type ProcessesUpdateStepExaminationResponse =
  ProcessesUpdateStepExaminationResponses[keyof ProcessesUpdateStepExaminationResponses];

export type ProcessesUpdateStepDecisionData = {
  body: UpdateProcessStepDecisionDto;
  path: {
    processId: string;
  };
  query: {
    action: ProcessAction;
  };
  url: '/api/processes/{processId}/step-decision';
};

export type ProcessesUpdateStepDecisionResponses = {
  200: Process;
};

export type ProcessesUpdateStepDecisionResponse =
  ProcessesUpdateStepDecisionResponses[keyof ProcessesUpdateStepDecisionResponses];

export type ProcessesUpdateStepExecutionData = {
  body: UpdateProcessStepExecutionDto;
  path: {
    processId: string;
  };
  query: {
    action: ProcessAction;
  };
  url: '/api/processes/{processId}/step-execution';
};

export type ProcessesUpdateStepExecutionResponses = {
  200: Process;
};

export type ProcessesUpdateStepExecutionResponse =
  ProcessesUpdateStepExecutionResponses[keyof ProcessesUpdateStepExecutionResponses];

export type ProcessesFinalizeProcessData = {
  body: FinalizeProcessDto;
  path: {
    processId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/step-finalization';
};

export type ProcessesFinalizeProcessResponses = {
  201: Process;
};

export type ProcessesFinalizeProcessResponse =
  ProcessesFinalizeProcessResponses[keyof ProcessesFinalizeProcessResponses];

export type ProcessesCancelProcessData = {
  body: CancelProcessDto;
  path: {
    processId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/cancel';
};

export type ProcessesCancelProcessResponses = {
  201: Process;
};

export type ProcessesCancelProcessResponse = ProcessesCancelProcessResponses[keyof ProcessesCancelProcessResponses];

export type ProcessesGeneratePdfData = {
  body?: never;
  path: {
    processId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/pdf';
};

export type ProcessesGeneratePdfResponses = {
  200: ProcessFile;
};

export type ProcessesGeneratePdfResponse = ProcessesGeneratePdfResponses[keyof ProcessesGeneratePdfResponses];

export type ProcessesFindAllFilesData = {
  body?: never;
  path: {
    processId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/files';
};

export type ProcessesFindAllFilesResponses = {
  200: Array<ProcessFileDto>;
};

export type ProcessesFindAllFilesResponse = ProcessesFindAllFilesResponses[keyof ProcessesFindAllFilesResponses];

export type ProcessesUploadFileData = {
  body: {
    file?: Blob | File;
  };
  path: {
    processId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/files';
};

export type ProcessesUploadFileResponses = {
  201: ProcessFile;
};

export type ProcessesUploadFileResponse = ProcessesUploadFileResponses[keyof ProcessesUploadFileResponses];

export type ProcessesRemoveFileData = {
  body?: never;
  path: {
    processId: string;
    fileId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/files/{fileId}';
};

export type ProcessesRemoveFileResponses = {
  200: ProcessFile;
};

export type ProcessesRemoveFileResponse = ProcessesRemoveFileResponses[keyof ProcessesRemoveFileResponses];

export type ProcessesFindOneFileData = {
  body?: never;
  path: {
    processId: string;
    fileId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/files/{fileId}';
};

export type ProcessesFindOneFileResponses = {
  default: Blob | File;
};

export type ProcessesFindOneFileResponse = ProcessesFindOneFileResponses[keyof ProcessesFindOneFileResponses];

export type ProcessesAddSignData = {
  body?: never;
  path: {
    processId: string;
    signId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/addSign/{signId}';
};

export type ProcessesAddSignResponses = {
  201: Process;
};

export type ProcessesAddSignResponse = ProcessesAddSignResponses[keyof ProcessesAddSignResponses];

export type ProcessesRemoveSignData = {
  body?: never;
  path: {
    processId: string;
    signId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/removeSign/{signId}';
};

export type ProcessesRemoveSignResponses = {
  200: Process;
};

export type ProcessesRemoveSignResponse = ProcessesRemoveSignResponses[keyof ProcessesRemoveSignResponses];

export type ProcessesCreateExaminationData = {
  body: CreateProcessExaminationDto;
  path: {
    processId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/examinations';
};

export type ProcessesCreateExaminationResponses = {
  201: ProcessExamination;
};

export type ProcessesCreateExaminationResponse =
  ProcessesCreateExaminationResponses[keyof ProcessesCreateExaminationResponses];

export type ProcessesRemoveExaminationData = {
  body?: never;
  path: {
    processId: string;
    examinationId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/examinations/{examinationId}';
};

export type ProcessesRemoveExaminationResponses = {
  200: ProcessExamination;
};

export type ProcessesRemoveExaminationResponse =
  ProcessesRemoveExaminationResponses[keyof ProcessesRemoveExaminationResponses];

export type ProcessesUpdateExaminationData = {
  body: UpdateProcessExaminationDto;
  path: {
    processId: string;
    examinationId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/examinations/{examinationId}';
};

export type ProcessesUpdateExaminationResponses = {
  200: ProcessExamination;
};

export type ProcessesUpdateExaminationResponse =
  ProcessesUpdateExaminationResponses[keyof ProcessesUpdateExaminationResponses];

export type ProcessesFindOneExaminationPublicData = {
  body?: never;
  path: {
    processId: string;
    examinationId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/public-examinations/{examinationId}';
};

export type ProcessesFindOneExaminationPublicResponses = {
  200: ProcessExamination;
};

export type ProcessesFindOneExaminationPublicResponse =
  ProcessesFindOneExaminationPublicResponses[keyof ProcessesFindOneExaminationPublicResponses];

export type ProcessesUpdateExaminationPublicData = {
  body: UpdateProcessExaminationDto;
  path: {
    processId: string;
    examinationId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/public-examinations/{examinationId}';
};

export type ProcessesUpdateExaminationPublicResponses = {
  200: ProcessExamination;
};

export type ProcessesUpdateExaminationPublicResponse =
  ProcessesUpdateExaminationPublicResponses[keyof ProcessesUpdateExaminationPublicResponses];

export type ProcessesFindOneExecutionPublicData = {
  body?: never;
  path: {
    processId: string;
  };
  query?: never;
  url: '/api/processes/{processId}/public-execution';
};

export type ProcessesFindOneExecutionPublicResponses = {
  200: PublicProcessDto;
};

export type ProcessesFindOneExecutionPublicResponse =
  ProcessesFindOneExecutionPublicResponses[keyof ProcessesFindOneExecutionPublicResponses];

export type ProcessesUpdateExecutionPublicData = {
  body: UpdateProcessExecutionDto;
  path: {
    processId: string;
  };
  query: {
    action: string;
  };
  url: '/api/processes/{processId}/public-execution';
};

export type ProcessesUpdateExecutionPublicResponses = {
  200: PublicProcessDto;
};

export type ProcessesUpdateExecutionPublicResponse =
  ProcessesUpdateExecutionPublicResponses[keyof ProcessesUpdateExecutionPublicResponses];

export type SignImagesFindAllData = {
  body?: never;
  path: {
    signId: string;
  };
  query?: never;
  url: '/api/sign-images/{signId}/images';
};

export type SignImagesFindAllResponses = {
  200: Array<SignImage>;
};

export type SignImagesFindAllResponse = SignImagesFindAllResponses[keyof SignImagesFindAllResponses];

export type SignImagesUploadData = {
  body: {
    file?: Blob | File;
  };
  path: {
    signId: string;
  };
  query?: never;
  url: '/api/sign-images/{signId}/images';
};

export type SignImagesUploadResponses = {
  201: SignImage;
};

export type SignImagesUploadResponse = SignImagesUploadResponses[keyof SignImagesUploadResponses];

export type SignImagesRemoveData = {
  body?: never;
  path: {
    signId: string;
    imageId: string;
  };
  query?: {
    /**
     * processId is used to delete images from signDraft and signExecution within the given process
     */
    processId?: string;
  };
  url: '/api/sign-images/{signId}/images/{imageId}';
};

export type SignImagesRemoveResponses = {
  200: SignImage;
};

export type SignImagesRemoveResponse = SignImagesRemoveResponses[keyof SignImagesRemoveResponses];

export type SignImagesFindOneData = {
  body?: never;
  path: {
    imageId: string;
  };
  query?: never;
  url: '/api/sign-images/{signId}/images/{imageId}';
};

export type SignImagesFindOneResponses = {
  default: Blob | File;
};

export type SignImagesFindOneResponse = SignImagesFindOneResponses[keyof SignImagesFindOneResponses];

export type ExternalSignsUploadData = {
  body: {
    file?: Blob | File;
  };
  path?: never;
  query?: never;
  url: '/api/external-signs/upload';
};

export type ExternalSignsUploadResponses = {
  201: unknown;
};

export type ExternalSignsImportData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/external-signs/import';
};

export type ExternalSignsImportResponses = {
  201: string;
};

export type ExternalSignsImportResponse = ExternalSignsImportResponses[keyof ExternalSignsImportResponses];

export type OpenLrImportData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/open-lr/import';
};

export type OpenLrImportResponses = {
  201: {
    [key: string]: unknown;
  };
};

export type OpenLrImportResponse = OpenLrImportResponses[keyof OpenLrImportResponses];
